<template>
    <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-green sm:bg-white">
        <div class="sm:w-[500px] py-16 sm:py-32 mx-auto bg-green px-8 sm:rounded-lg">
            <inertia-link href="/">
                <img src="/img/livefarm_logo_white.svg"
                    alt="Livefarm" title="Livefarm"
                    class="w-48 mx-auto">
            </inertia-link>

            <div class="w-full sm:max-w-sm mt-2 px-6 py-4 mx-auto">
                <slot />
            </div>
        </div>
    </div>
</template>
